import { AutogenModelOfferManagement, AutogenRowOfferManagement } from "./autogen/AutogenModelOfferManagement";

export class ModelOfferManagement extends AutogenModelOfferManagement<RowOfferManagement> {
    constructor() {
        super(RowOfferManagement);
    }
}

export class RowOfferManagement extends AutogenRowOfferManagement {
}